import { useMediaQuery } from '@mui/material';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useState } from 'react';
import Inspector from './Inspector';

const Block = ({ disableSubmit, defaultText, hoverText, defaultEmoji, hoverEmoji }) => {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();
    const isMobile = useMediaQuery(`(max-width: ${style.mobileBreakpoint})`);

    const [hovered, setHovered] = useState(false);

    const transition = {
        type: 'spring',
        stiffness: 500,
        damping: 15,
        duration: 0.1,
    };

    const textVariants = {
        initial: { y: 0, transition: transition },
        hover: { y: isMobile ? 0 : -75, transition: transition },
    };

    const textVariantsHover = {
        initial: { y: 75, transition: transition },
        hover: { y: 0, transition: transition },
    };

    const emojiVariants = {
        initial: { y: 0, transition: transition },
        hover: { y: isMobile ? 0 : 75, transition: transition },
    };

    const emojiVariantsHover = {
        initial: { y: -75, transition: transition },
        hover: { y: 0, transition: transition },
    };

    return (
        <BlockWrapper.Div className={style.block}>
            <motion.button
                onHoverStart={() => setHovered(true)}
                onHoverEnd={() => setHovered(false)}
                className={clsx(style.button, disableSubmit && style.disabled)}
                style={{
                    color: style.blue,
                    backgroundColor: style.green,
                }}
                disabled={disableSubmit}
                type={isEditing ? 'button' : 'submit'}
            >
                <div className={style.row}>
                    {!isMobile && (
                        <motion.div
                            variants={emojiVariants}
                            initial="initial"
                            animate={hovered ? 'hover' : 'initial'}
                            className={style.emoji}
                        >
                            {defaultEmoji}
                        </motion.div>
                    )}
                    <motion.div variants={textVariants} initial="initial" animate={hovered ? 'hover' : 'initial'}>
                        {defaultText}
                    </motion.div>
                    {!isMobile && (
                        <motion.div
                            variants={emojiVariants}
                            initial="initial"
                            animate={hovered ? 'hover' : 'initial'}
                            className={style.emoji}
                        >
                            {defaultEmoji}
                        </motion.div>
                    )}
                </div>
                {!isMobile && (
                    <div className={style.row}>
                        <motion.div
                            variants={emojiVariantsHover}
                            initial="initial"
                            animate={hovered ? 'hover' : 'initial'}
                            className={style.emoji}
                        >
                            {hoverEmoji}
                        </motion.div>
                        <motion.div
                            variants={textVariantsHover}
                            initial="initial"
                            animate={hovered ? 'hover' : 'initial'}
                        >
                            {hoverText}
                        </motion.div>
                        <motion.div
                            variants={emojiVariantsHover}
                            initial="initial"
                            animate={hovered ? 'hover' : 'initial'}
                            className={style.emoji}
                        >
                            {hoverEmoji}
                        </motion.div>
                    </div>
                )}
            </motion.button>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        defaultText: smartProps.string.withDefault('Je participe'),
        hoverText: smartProps.string.withDefault('Tu valides ?'),
        defaultEmoji: smartProps.string.withDefault('🤞'),
        hoverEmoji: smartProps.string.withDefault('🫣'),
    },
    setup: {
        title: "Bouton d'envoi",
        parent: ['smartform/quiz-form', 'smartfire/quiz-form---two-columns'],
    },
});
